var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('qrcode-stream',{on:{"click":_vm.reload,"decode":_vm.onDecode,"init":_vm.onInit}},[(_vm.loading)?_c('div',{staticClass:"loading-indicator"},[_vm._v(" Loading... ")]):_vm._e()]),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }